var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-loader"},[_c('img',{attrs:{"src":require("@/assets/loadingfish.gif"),"alt":"loading..."}}),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }